import { Link as RouterLink } from 'react-router-dom';
// @mui
import { BoxProps, Stack } from '@mui/material';
import Image from './Image';
import logoImage from '../assets/logo.png';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  const logo = (
    <Stack alignItems="center" justifyContent="center">
      <Image sx={{ width: 100, ...sx }} src={logoImage} />
    </Stack>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
